import { i as e, l as t } from "./chunk-lit-CcXdLsKL.js";
import { t as n } from "./chunk-BaseElement-DTFzty-z.js";
import { c as r, s as i, t as a } from "./chunk-decorate-D_r-8Fip.js";
import { t as o } from "./chunk-task-et_RqNua.js";
import { t as s } from "./chunk-unsafe-html-Dq9TccDR.js";
//#region src/styles/component-icon.css?inline
var c = "/*! tailwindcss v4.2.4 | MIT License | https://tailwindcss.com */\nsvg{width:100%;height:100%}", l = class extends n {
	static {
		this.styles = [t(c)];
	}
	constructor() {
		super(), this.iconAssetUrl = window.routes.icons, this._svgTask = new o(this, {
			task: async ([e], { signal: t }) => {
				let n = `${this.iconAssetUrl}/${e}.svg`, r = await fetch(n, { signal: t });
				if (!r.ok) throw Error(r.statusText);
				return await r.text();
			},
			args: () => [this.src]
		});
	}
	connectedCallback() {
		super.connectedCallback();
	}
	render() {
		return this._svgTask.render({
			pending: () => e`<span><!--loading icon--></span>`,
			complete: (t) => e`
          <div class="block h-full w-full">${s(t)}</div>
        `,
			error: () => e`<span><!--Error loading icon--></span>`
		}) || e`<span><!--Error loading icon--></span>`;
	}
};
a([i({ type: String })], l.prototype, "src", void 0), l = a([r("svg-icon")], l);
//#endregion
export { l as SvgIcon };
